import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  HTTP_GETTYPE,
  PAGE_SIZE_IMAGE,
  STATUS_API,
  MSG_TIMEOUT_REQUEST,
  TIMEOUT_DEFAULT,
  messageToastType_const,
} from 'src/app/constant/config';
import AxiosAdapter from './AxiosAdapter';
import axios from '../app/axiosInterceptor';
import { MESSAGE } from 'src/app/constant/message';
import { showGlobalToast } from './uiSlice';

export const getListDriver = AxiosAdapter.HttpGetById(
  'driverSlice/GetListDriver',
  '/drivers/agency',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListDriverForUser = AxiosAdapter.HttpGetById(
  'driverSlice/getListDriverForUser',
  '/drivers/end_user',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListDriverAccount = AxiosAdapter.GetHttp(
  'driverSlice/getListDriverAccount',
  '/drivers/sub-accounts',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListDriverAdmin = AxiosAdapter.GetHttp(
  'driverSlice/GetListDriver',
  '/drivers'
);

export const createDriver = AxiosAdapter.HttpPost(
  'driverSlice/createDriver',
  '/drivers',
  MESSAGE.CREATE_DRIVER_SUCCESS,
  'Tạo lái xe thất bại'
);

export const createDriverAccount = createAsyncThunk(
  'driverSlice/createDriverAccount',
  async ({ username, password }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios({
        url: `/drivers/create/sub-account`,
        method: 'POST',
        data: { username, password },
        timeout: TIMEOUT_DEFAULT
      });

      dispatch(
        showGlobalToast({
          message: response?.data?.message || 'Tạo tài khoản lái xe thành công',
          type: messageToastType_const.success
        })
      );

      return response.data;
    } catch (err) {

      dispatch(
        showGlobalToast({
          message: err?.response?.data?.message || 'Tạo tài khoản lái xe thất bại',
          type: messageToastType_const.error
        })
      );

      return rejectWithValue(err?.response?.data || err);
    }
  }
);

export const assignDeviceToDriver = createAsyncThunk(
  'driverSlice/assignDeviceToDriver',
  async ({ userId, device_ids, driverId = null }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios({
        url: `/drivers/assign-device/${userId}`,
        method: 'POST',
        data: {
          device_ids,
          driverId
        },
        timeout: TIMEOUT_DEFAULT
      });

      dispatch(
        showGlobalToast({
          message: response?.data?.message || 'Gán thiet bi cho tai xe thanh cong',
          type: messageToastType_const.success
        })
      );

      return response.data;
    } catch (err) {
      dispatch(
        showGlobalToast({
          message: err?.response?.data?.message || 'Gán thiet bi cho tai xe that bai',
          type: messageToastType_const.error
        })
      );

      return rejectWithValue(err?.response?.data || err);
    }
  }
);

export const getAssignableDriverDevices = createAsyncThunk(
  'driverSlice/getAssignableDriverDevices',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios({
        url: '/devices/assignable/driver',
        method: 'GET',
        timeout: TIMEOUT_DEFAULT
      });

      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || err);
    }
  }
);

export const getListDriverLicenseType = AxiosAdapter.GetHttp(
  'driver/drivertype',
  '/driver_license_type',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const updateDrivers = AxiosAdapter.HttpUpdateById(
  'driverSlice/updateDrivers',
  '/drivers/agency',
  MESSAGE.UPDATE_DRIVER_SUCCESS,
  'Cập nhật lái xe thất bại'
);

export const updateDriverAccountPassword = AxiosAdapter.HttpPut(
  'driverSlice/updateDriverAccountPassword',
  '/drivers/sub-account/',
  'Cập nhật mật khẩu tài khoản lái xe thành công',
  'Cập nhật mật khẩu tài khoản lái xe thất bại'
);


export const deleteDriverAccount = AxiosAdapter.HttpDelete(
  'driverSlice/deleteDriverAccount',
  '/drivers/sub-account',
  'Xóa tài khoản lái xe thành công',
  'Xóa tài khoản lái xe thất bại'
);

export const deleteDrivers = createAsyncThunk(
  'driverSlice/deleteDrivers',
  (payload, { dispatch, rejectWithValue }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${process.env.REACT_APP_BACKEND_URL}/drivers/agency/${payload.agencyId}`,
        method: 'Delete',
        headers: {
          'Access-Control-Allow-Origin': true,
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + localStorage.getItem('access-token'),
          timeout: TIMEOUT_DEFAULT
        },
        data: payload.listAgenciesId
      })
        .then(res => {
          if (MESSAGE.DELETE_DRIVER_SUCCESS) {
            dispatch(
              showGlobalToast({
                message: MESSAGE.DELETE_DRIVER_SUCCESS,
                type: messageToastType_const.success
              })
            );
          }
          resolve(res.data);
        })
        .catch(err => {
          if (err.code === 'ECONNABORTED') reject(MSG_TIMEOUT_REQUEST);
          if (!err.response) reject(err);
          if ('Xóa lái xe thất bại') {
            dispatch(
              showGlobalToast({
                message: err?.response?.data?.message || 'Xóa lái xe thất bại',
                type: messageToastType_const.error
              })
            );
          }
          reject(rejectWithValue(err.response?.data));
        });
    });
  }
);

export const driverSlice = createSlice({
  name: 'driverSlice',
  initialState: {
    listDriver: null,
    listDriverAccounts: null,
    totalDriver: 0,
    totalDriverAccount: 0,
    statusGet: null,
    statusCreate: null,
    statusDelete: null,
    statusDeleteMulti: null,
    statusUpdate: null,
    errors: null,
    totalPage: 0,
    isLoading: false,
    
    statusGetDriverAccount: null,
    statusGetDriverDevices: null,
    statusCreateAccount: null,
    statusDeleteAccount: null,
    statusUpdatePassword: null,
    statusAssignDevice: null,
    driverDevices: null,
  },

  reducers: {
    resetChange: state => {
      state.listDriver = null;
      state.listDriverAccounts = null;
      state.totalDriver = 0;
      state.totalDriverAccount = 0;
      state.statusGet = null;
      state.statusGetDriverAccount = null;
      state.statusGetDriverDevices = null;
      state.userSelected = null;
      state.selectedLicensePlate = null;
      state.statusCreate = null;
      state.statusCreateAccount = null;
      state.statusDelete = null;
      state.statusDeleteMulti = null;
      state.statusUpdate = null;
      state.errors = null;
      state.statusDeleteAccount = null;
      state.statusUpdatePassword = null;
      state.statusAssignDevice = null;
      state.driverDevices = null;
    }
  },
  extraReducers: {
    [getListDriver.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDriver.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listDriver = action.payload.payload.drivers;
      state.totalDriver = action.payload.payload.numberOfItem;
      state.totalPage =
        action.payload.payload.numberOfItem % PAGE_SIZE_IMAGE === 0
          ? action.payload.payload.numberOfItem / PAGE_SIZE_IMAGE
          : Math.ceil(action.payload.payload.numberOfItem / PAGE_SIZE_IMAGE);

      state.isLoading = false;
    },
    [getListDriver.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [getListDriverForUser.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDriverForUser.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listDriver = action.payload.payload.drivers;
      state.totalDriver = action.payload.payload.numberOfItem;
      state.totalPage =
        action.payload.payload.numberOfItem % PAGE_SIZE_IMAGE === 0
          ? action.payload.payload.numberOfItem / PAGE_SIZE_IMAGE
          : Math.ceil(action.payload.payload.numberOfItem / PAGE_SIZE_IMAGE);

      state.isLoading = false;
    },
    [getListDriverForUser.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [getListDriverAccount.pending]: state => {
      state.statusGetDriverAccount = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDriverAccount.fulfilled]: (state, action) => {
      state.statusGetDriverAccount = STATUS_API.SUCCESS;
      state.listDriverAccounts = action.payload.payload.sub_accounts;
      state.totalDriverAccount = action.payload.payload.total;
      state.isLoading = false;
    },
    [getListDriverAccount.rejected]: (state, action) => {
      state.statusGetDriverAccount = STATUS_API.ERROR;
      state.errors = action.payload?.message;
      state.isLoading = false;
    },
    [getListDriverAdmin.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListDriverAdmin.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listDriver = action.payload.payload.drivers;
      state.totalDriver = action.payload.payload.numberOfItem;
      state.totalPage =
        action.payload.payload.numberOfItem % PAGE_SIZE_IMAGE === 0
          ? action.payload.payload.numberOfItem / PAGE_SIZE_IMAGE
          : Math.ceil(action.payload.payload.numberOfItem / PAGE_SIZE_IMAGE);

      state.isLoading = false;
    },
    [getListDriverAdmin.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [createDriver.pending]: state => {
      state.statusCreate = STATUS_API.PENDING;
    },
    [createDriver.fulfilled]: (state, action) => {
      state.statusCreate = STATUS_API.SUCCESS;
    },
    [createDriver.rejected]: (state, action) => {
      state.statusCreate = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },
    [createDriverAccount.pending]: state => {
      state.statusCreateAccount = STATUS_API.PENDING;
    },
    [createDriverAccount.fulfilled]: state => {
      state.statusCreateAccount = STATUS_API.SUCCESS;
    },
    [createDriverAccount.rejected]: (state, action) => {
      state.statusCreateAccount = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },
    [assignDeviceToDriver.pending]: state => {
      state.statusAssignDevice = STATUS_API.PENDING;
    },
    [assignDeviceToDriver.fulfilled]: state => {
      state.statusAssignDevice = STATUS_API.SUCCESS;
    },
    [assignDeviceToDriver.rejected]: (state, action) => {
      state.statusAssignDevice = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },
    [getAssignableDriverDevices.pending]: state => {
      state.statusGetDriverDevices = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getAssignableDriverDevices.fulfilled]: (state, action) => {
      state.statusGetDriverDevices = STATUS_API.SUCCESS;
      state.driverDevices = action.payload?.payload || action.payload;
      state.isLoading = false;
    },
    [getAssignableDriverDevices.rejected]: (state, action) => {
      state.statusGetDriverDevices = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [getListDriverLicenseType.fulfilled]: (state, action) => {
      state.listDriverLicenseType = action.payload.payload.driver_license_type;
    },
    [deleteDrivers.pending]: state => {
      state.statusDelete = STATUS_API.PENDING;
    },
    [deleteDrivers.fulfilled]: (state, action) => {
      state.statusDelete = STATUS_API.SUCCESS;
    },
    [deleteDrivers.rejected]: (state, action) => {
      state.statusDelete = STATUS_API.ERROR;
      state.errors = action.payload.message || action.error;
    },
    [updateDrivers.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateDrivers.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateDrivers.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },
    [updateDriverAccountPassword.pending]: state => {
      state.statusUpdatePassword = STATUS_API.PENDING;
    },
    [updateDriverAccountPassword.fulfilled]: state => {
      state.statusUpdatePassword = STATUS_API.SUCCESS;
    },
    [updateDriverAccountPassword.rejected]: (state, action) => {
      state.statusUpdatePassword = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    },
    [deleteDriverAccount.pending]: state => {
      state.statusDeleteAccount = STATUS_API.PENDING;
    },
    [deleteDriverAccount.fulfilled]: state => {
      state.statusDeleteAccount = STATUS_API.SUCCESS;
    },
    [deleteDriverAccount.rejected]: (state, action) => {
      state.statusDeleteAccount = STATUS_API.ERROR;
      state.errors = action.payload?.message || action.error;
    }
  }
});
export const { resetChange } = driverSlice.actions;

export default driverSlice.reducer;
